import React from 'react';

interface Props {
  path: string | null;
  content: string | null;
  loading: boolean;
  error: string | null;
}

const CodeViewer: React.FC<Props> = ({ path, content, loading, error }) => {
  if (!path) {
    return (
      <div className="h-full flex items-center justify-center text-center text-sm text-gray-500 dark:text-gray-400 p-6">
        <div className="max-w-xs">
          <div className="text-4xl mb-2 opacity-30">{'< >'}</div>
          <p>Click a file in the workspace to preview its content.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col overflow-hidden bg-gray-50 dark:bg-gray-900/40">
      <div className="text-xs font-mono text-gray-700 dark:text-gray-300 px-4 py-2 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shrink-0 truncate" title={path}>
        {path}
      </div>
      <div className="flex-1 overflow-auto">
        {loading && (
          <div className="text-center text-sm text-gray-500 p-6">Loading {path}…</div>
        )}
        {error && !loading && (
          <div className="text-center text-sm text-red-600 dark:text-red-400 p-6">{error}</div>
        )}
        {!loading && !error && (
          <pre className="text-xs font-mono p-4 whitespace-pre-wrap text-gray-800 dark:text-gray-200 leading-relaxed">
            {content || '(empty file)'}
          </pre>
        )}
      </div>
    </div>
  );
};

export default CodeViewer;
